import SFM from '../images/sfm-logo.svg';
import EmailDefence from '../images/emaildefence-logo.svg';
import Phish from '../images/phishdefence.svg';
import Spam from '../images/spamdefence.svg';
import Email from '../images/emaildlp.svg';
import Encryption from '../images/emailencryption.svg';
import Attacks from '../images/attacksimulation.svg';
import DLP from '../images/dlp-logo.svg';
import Device from '../images/device-control.svg';
import Encry from '../images/encryption.svg';
import App from '../images/application-control.svg';
import Browser from '../images/browser-control.svg';
import './SecureForMe.css';
function SecureForMe() {
    return(
        <>
            <section class="secureforme-section">
                <div class="container">
                    <div class="secureforme">
                        {/* <div class="sfm-main wow pulse">
                            <img class="img-fluid" src={SFM} alt="" />
                        </div> */}
                        <div class="row">
                            <div class="col-lg-8 wow zoomIn">
                                <div class="effortly-content">
                                    <h2>Secure Your Emails</h2>
                                    <p>Provide greatest defence against email threats for your employees and customers with
                                        advanced and AI
                                        powered email security solution from EmailDefence</p>
                                </div>
                            </div>
                            <div class="col-lg-4 wow flipInX">
                                <div class="effortly-content-logo">
                                    <img class="img-fluid" src={EmailDefence} alt="effortly-logo" />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-lg-4">
                                <div class="row">
                                    <div class="col-md-6 col-lg-12">
                                        <div class="sfm-card">
                                            <img class="img-fluid" src={Phish} alt="" /> 
                                            <div class="sfm-card-content">
                                                <h3>Phish Defence</h3>
                                                <p>Thwarts various phishing attacks including Email Phishing, Spear Phishing,
                                                    HTTPS Phishing,
                                                    Whaling, Social Engineering, and more</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-12">
                                        <div class="sfm-card">
                                            <img class="img-fluid" src={Spam} alt="" />
                                            <div class="sfm-card-content">
                                                <h3>Spam Defence</h3>
                                                <p>Safeguard your emails and workforce from spam, shielding against malware,
                                                    zero-day attacks, and
                                                    other sophisticated threats detrimental to business operations</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="sfm-card sfm-card-addon">
                                            <img class="img-fluid" src={Email} alt="" />
                                            <div class="sfm-card-content addon">
                                                <h3>Email DLP</h3>
                                                <p>Ensures sensitive data, such as PHI/PII, login credentials, health and
                                                    financial records, and
                                                    proprietary information, remains secure.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <div class="col-md-6 col-lg-12">
                                        <div class="sfm-card">
                                            <img class="img-fluid" src={Encryption} alt="" />
                                            <div class="sfm-card-content">
                                                <h3>Email Encryption</h3>
                                                <p>End-to-end encryption prevents email messages from being read by unintended
                                                    or unauthorized
                                                    users, ensuring data security and confidentiality.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-12">
                                        <div class="sfm-card spacing">
                                            <img class="img-fluid" src={Attacks} alt="" />
                                            <div class="sfm-card-content">
                                                <h3>User Training & Attack Simulation</h3>
                                                <p>Improves employee response to security threats through tutorials, tests, and
                                                    realistic simulated phishing attacks.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dlpdefence">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="effortly-content wow zoomIn">
                                    <h2>Defend Your Data with DLP Solution </h2>
                                    <p>Safeguard sensitive information by monitoring, detecting, and preventing unauthorized
                                        data transfers or
                                        leaks.</p>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="effortly-content-logo wow flipInX">
                                    <img class="img-fluid" src={DLP} alt="effortly-logo" />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-1 wow fadeInUp">
                            <div class="col-md-6">
                                <div class="dlp-card">
                                    <div class="effortly-card-content">
                                        <h3>Device Control</h3>
                                        <p>Empower administrators to efficiently manage and secure endpoints, controlling access
                                            to USB devices,
                                            printers, and other peripherals.</p>
                                    </div>
                                    <img class="img-fluid" src={Device} alt="" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="dlp-card">
                                    <div class="effortly-card-content">
                                        <h3>Encryption</h3>
                                        <p>Safeguard sensitive information with advanced encryption techniques, shielding it
                                            from unauthorized
                                            access or breaches and loss of data.</p>
                                    </div>
                                    <img class="img-fluid" src={Encry} alt="" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="dlp-card">
                                    <div class="effortly-card-content">
                                        <h3>Application Control</h3>
                                        <p>Regulate and manage the usage of applications across your network, ensuring
                                            compliance and security.
                                        </p>
                                    </div>
                                    <img class="img-fluid" src={App} alt="" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="dlp-card">
                                    <div class="effortly-card-content">
                                        <h3>Browser Control</h3>
                                        <p>Manage and monitor internet usage by enforcing policies to regulate access and ensure
                                            security
                                            compliance and gain control over browsing activities.</p>
                                    </div>
                                    <img class="img-fluid" src={Browser} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
        </>
    );
}
export default SecureForMe;